import React, {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {useRecoilState} from "recoil";
import {unitsAtom, unitsEnumAtom} from "../../state/rentalPeriodsRecoil";
import {ancillaryTypeAtom, chargingWayAtom, currencyAtom} from "../../state/constantsRecoil";
import {fromGenericBeToGenericFe} from "../../utils";
import {SET_SNACKBAR} from "../../constants";
import {useLocation, useParams} from "react-router-dom";
import OWAncillaryBaseDefinition from "./BaseDefinition/OWAncillaryBaseDefinition";
import DialogComponent from "../../common/components/DialogComponent";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {useOWAncillaryRepository} from "../../api/repositories/OWAncillaryRepository";
import {useConstantsRepository} from "../../api/repositories/ConstantsRepository";
import {useTpUnitRepository} from "../../api/repositories/TpUnitRepository";
import Loading from "../../common/components/Loading";
import {Box, Grid, Tab, Tabs} from "@mui/material";
import {useTranslation} from "react-i18next";
import {
    DialogInterface,
    SelectElementModelBE,
    SelectElementModelFE,
    UseLocationStateModel
} from "../../api/types/generic";
import {
    FormOWAncillaryModel,
    OWAncillaryEntityRequest,
    OWAncillaryEntityResponse
} from "../../api/types/owAncillary";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {FormProvider, useForm} from "react-hook-form";
import {useCommercialSegmentRepository} from "../../api/repositories/CommercialSegmentRepository";
import {commercialSegmentListAtom} from "../../state/commercialSegmentsAtom";
import OWRouteMatrix from "./Matrix/OWRouteMatrix";
import {useProviderRepository} from "../../api/repositories/ProviderRepository";
import {owAncillaryAtom} from "../../state/owAncillariesRecoil";
import {useAncillaryRepository} from "../../api/repositories/AncillaryRepository";
import {getAncillaryBaseDefinitionValidationSchema} from "../Ancillary/BaseDefinition/AncillaryBaseDefinitionForm";
import {RouteParams, TaxCodeObject} from "../../api/types/ancillary";
import {
    buildEntityRequestFromFormValues,
    buildOWAncillaryForm,
    initialOWAncillaryForm
} from "./BaseDefinition/OWAncillaryBaseDefinitionForm";
import {ancillaryServiceItem} from "../../state/ancillariesRecoil";

type TabPanelProps = {
    children?: React.ReactNode;
    index: number;
    value: number;
};

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{p: 3}}>{children}</Box>}
        </div>
    );
}

const OWAncillaryContent = ({
                                readOnly,
                                owAncillaryId
                            }: {
    readOnly: boolean;
    owAncillaryId?: number;
}) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Context
    const {dispatchGlobalData, globalData: {user}} = useContext(GlobalContext);

    //setto tutte le legalEntities options e le passo al filtro di ricerca ["all", "drivalia_it","drivalia_fr"]
    const legalEntityOptions: SelectElementModelFE[] = user.legalEntities?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:legalEntities.'.concat(el.name))
        })
    );

    //se utente clicca su all, mando  ["drivalia_it","drivalia_fr"]
    const optionsFiltered = legalEntityOptions
        .filter(function (el) {
            return el.code !== "all";
        });

    const everyLegalEntitiesWithoutAll = legalEntityOptions
        .map((el) => el.code as string)
        .filter((el) => el !== "all");

    //setto tutti i dealers options
    const dealerOption: SelectElementModelFE[] = user.dealers?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:dealers.'.concat(el.name))
        })
    );

    const dealerFilteredOptions = dealerOption
        .map((el) => el.code as string)
        .filter((el) => el !== "all");

    const {id} = useParams<RouteParams>();

    // Use Location
    const location = useLocation();
    const locationState: UseLocationStateModel = location.state as UseLocationStateModel;

    // Use Recoil
    const [, setCommercialSegmentList] = useRecoilState(commercialSegmentListAtom);
    const [, setUnits] = useRecoilState(unitsAtom);
    const [, setUnitsEnum] = useRecoilState<string[]>(unitsEnumAtom);
    const [, setCurrencies] = useRecoilState(currencyAtom);
    const [, setChargingWays] = useRecoilState(chargingWayAtom);
    const [, setAncillaryTypes] = useRecoilState(ancillaryTypeAtom);
    const [owAncillary, setOWAncillary] = useRecoilState<OWAncillaryEntityResponse | null>(owAncillaryAtom);
    const [serviceItem, setServiceItem] = useRecoilState<any>(ancillaryServiceItem)

    // Use State
    const [providers, setProviders] = useState<SelectElementModelFE[]>([]);
    const [owAncillaryForm, setOWAncillaryForm] = useState<FormOWAncillaryModel | null>(null);
    const [originalOWAncillaryForm, setOriginalOWAncillaryForm] = useState<FormOWAncillaryModel | null>(null);
    const [value, setValue] = useState<number>(0);
    const [dialog, setDialog] = useState<DialogInterface | null>(null);
    const [ancillaryInUse, setAncillaryInUse] = useState<boolean>(false);


    // Use Repository Hooks
    const {getOWAncillary, putOWAncillary, postOWAncillary} = useOWAncillaryRepository();
    const {getAncillaryInUse, getServiceItem} = useAncillaryRepository();
    const {getCurrencies, getChargingWays, getTypes} = useConstantsRepository();
    const {getTpUnits} = useTpUnitRepository();
    const {getTpUnitsEnum} = useConstantsRepository();
    const {getCommercialSegments} = useCommercialSegmentRepository();
    const {getProviders} = useProviderRepository();

    const handleSubmit = (values: FormOWAncillaryModel) => {
        const owAncillaryEntityRequest: OWAncillaryEntityRequest = buildEntityRequestFromFormValues(values, ancillaryInUse, everyLegalEntitiesWithoutAll, dealerFilteredOptions);
        let notDateFieldsAreUpdated;
        // UPDATE ANCILLARY BASE
        if (originalOWAncillaryForm && owAncillaryForm?.id) {
            const updateOWAncillary: OWAncillaryEntityResponse = {
                id: owAncillaryForm?.id,
                prcAncillary: {...owAncillaryEntityRequest.prcAncillary, id: owAncillary?.prcAncillary.id as number}
            };
            setOWAncillary(updateOWAncillary)
            if (owAncillary) {
                notDateFieldsAreUpdated = checkValues(
                    {
                        ...owAncillary
                    },
                    updateOWAncillary
                );
            }
        }

        setDialog({
            open: true,
            message: owAncillaryForm?.id
                ? notDateFieldsAreUpdated && ancillaryInUse
                    ? t("pricing:ancillaryOW.banner")
                    : t("pricing:ancillaryOW.dialogContents.updateAncillaryBase")
                : t("pricing:ancillaryOW.dialogContents.createAncillaryBase"),
            onClickConfirm: () => submit(values, owAncillaryEntityRequest),
        });
    };

    // Use Form
    const form = useForm<FormOWAncillaryModel>({
        defaultValues: owAncillaryForm || initialOWAncillaryForm(legalEntityOptions, dealerOption),
        resolver: yupResolver(
            getAncillaryBaseDefinitionValidationSchema(
                t,
                owAncillary ? owAncillary.prcAncillary : null
            ),
            // getOWAncillaryBaseDefinitionValidationSchema(t, owAncillary ? owAncillary.prcAncillary : null),
            {},
            {
                rawValues: true,
            }
        ),
        shouldUnregister: false,
    });

    const checkValues = (
        originalOWAncillaryForm: OWAncillaryEntityResponse,
        owAncillaryForm: OWAncillaryEntityResponse
    ): boolean => {
        //converti in stringa, assegna a oggetto x non perderli, togliere date da oggetto nuovo, stringare,  confrontare stringhe senza date
        const firstStringOriginalOWAncillary = JSON.stringify(
            originalOWAncillaryForm
        );
        const firstStringOWAncillary = JSON.stringify(owAncillaryForm);

        const objectOriginalOWAncillary = JSON.parse(
            firstStringOriginalOWAncillary
        );
        const objectOWAncillary = JSON.parse(firstStringOWAncillary);

        delete objectOriginalOWAncillary.pickupFrom;
        delete objectOriginalOWAncillary.pickupTo;
        delete objectOriginalOWAncillary.reservationFrom;
        delete objectOriginalOWAncillary.reservationTo;

        delete objectOWAncillary.pickupFrom;
        delete objectOWAncillary.pickupTo;
        delete objectOWAncillary.reservationFrom;
        delete objectOWAncillary.reservationTo;

        const updatedStringOriginalOWAncillary = JSON.stringify(
            Object.entries(objectOriginalOWAncillary).sort()
        );
        const updatedStringOWAncillary = JSON.stringify(
            Object.entries(objectOWAncillary).sort()
        );

        return updatedStringOriginalOWAncillary !== updatedStringOWAncillary;
    };

    const submit = async (
        values: FormOWAncillaryModel,
        owAncillaryEntityRequest: OWAncillaryEntityRequest
    ) => {
        const owAncillaryRequest: OWAncillaryEntityRequest =
            owAncillaryEntityRequest;

        try {
            const taxCodeObject = owAncillaryEntityRequest.prcAncillary.taxCode as unknown as TaxCodeObject;
            owAncillaryEntityRequest.prcAncillary.taxCode = serviceItem.find(
                (item: any) => item.name === owAncillaryEntityRequest.prcAncillary.taxCode
            )?.code || taxCodeObject.value;

            const persistedOWAncillary = owAncillaryForm?.id
                ? await putOWAncillary({
                    id: owAncillaryForm?.id,
                    prcAncillary: {
                        ...owAncillaryRequest.prcAncillary,
                        id: owAncillary?.prcAncillary.id as number,
                    },
                })
                : await postOWAncillary(owAncillaryRequest);

            form.reset();
            dispatchGlobalData(SET_SNACKBAR.SUCCESS);
            const newOWAncillaryForm: FormOWAncillaryModel =
                buildOWAncillaryForm(persistedOWAncillary, t, serviceItem);
            setOWAncillaryForm(newOWAncillaryForm);
            setOWAncillary(persistedOWAncillary);
            form.reset(newOWAncillaryForm);
            setDialog(null);
            setValue(1);
        } catch (e) {
        }
    };

    const getStaticContents = async () => {
        try {
            const tpUnitsData = await getTpUnitsEnum();
            const currenciesData = await getCurrencies();
            const chargingWaysData = await getChargingWays();
            const typesData = await getTypes();

            // TODO: togliere COMMERCIAL_SEGMENTS || quando si pusha
            // const commercialSegmentsData = COMMERCIAL_SEGMENTS || await getCommercialSegments();
            const commercialSegmentsData = await getCommercialSegments();

            //const providersData = await getProviders();

            setUnitsEnum(tpUnitsData);

            const commercialSegmentList: SelectElementModelFE[] =
                fromGenericBeToGenericFe(commercialSegmentsData);
            setCommercialSegmentList(commercialSegmentList);

            //const providersList: SelectElementModelFE[] = fromGenericBeToGenericFe(providersData);
            //setProviders(providersList);

            setCurrencies(currenciesData);
            setChargingWays(chargingWaysData);
            setAncillaryTypes(typesData);

            if (
                (id || locationState?.owAncillaryId || owAncillaryId) &&
                !owAncillaryForm?.id
            ) {
                const owAncillary = await getOWAncillary((id || locationState?.owAncillaryId || owAncillaryId) as number);

                if (owAncillary) {
                    const ancillaryInUse: boolean = await getAncillaryInUse({
                        ancillaryId: owAncillary.prcAncillary.id,
                    });

                    const services = await getServiceItem(owAncillary.prcAncillary.legalEntity, owAncillary.prcAncillary.dealer);
                    setServiceItem(services);

                    setAncillaryInUse(ancillaryInUse);
                    const owAncillaryForm: FormOWAncillaryModel =
                        buildOWAncillaryForm(owAncillary, t, services);
                    setOWAncillary(owAncillary);
                    form.reset(owAncillaryForm);
                    setOWAncillaryForm(owAncillaryForm);
                    const originalOWAncillaryForm: FormOWAncillaryModel = JSON.parse(
                        JSON.stringify(owAncillaryForm)
                    );

                    setOriginalOWAncillaryForm(originalOWAncillaryForm);
                }
            }
        } catch (e) {
        }
    };

    // Use Effect
    useEffect(() => {
        getStaticContents();
        // eslint-disable-next-line
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        // click su matrice dei prezzi ma ancillary non ancora creata
        if (newValue === 1 && !owAncillaryForm?.id && !readOnly) {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t(
                            "pricing:ancillary.dialogContents.createAncillaryMatrix"
                        ),
                        type: snackbarTypes.warning,
                        show: true,
                        autoClose: true,
                    },
                },
            });
        } else if (newValue === 0 && !readOnly) {
            setDialog({
                open: true,
                message: t("pricing:dialogs.messages.looseChanging"),
                onClickConfirm: () => {
                    setDialog(null);
                    setValue(newValue);
                },
            });
        }
        // click su ancillary
        else {
            setValue(newValue);
        }
    };

    return (
        <Grid sx={{padding: 0}}>
            <Box sx={{borderBottom: 1, borderColor: "divider"}}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                >
                    <Tab
                        label={t("pricing:ancillary.title")}
                    />
                    <Tab
                        label={t("pricing:ancillaryMatrix.title")}
                    />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <FormProvider {...form}>
                    <OWAncillaryBaseDefinition
                        readOnly={readOnly}
                        handleSubmit={form.handleSubmit(handleSubmit)}
                        providers={providers}
                        ancillaryInUse={ancillaryInUse}
                    />
                </FormProvider>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <OWRouteMatrix
                    owAncillaryId={
                        owAncillaryId ||
                        locationState?.owAncillaryId ||
                        owAncillaryForm?.id ||
                        null
                    }
                    readOnly={readOnly}
                    ancillaryInUse={ancillaryInUse}
                    setValue={setValue}
                />
            </TabPanel>
            {dialog?.open && (
                <DialogComponent
                    type={"info"}
                    onClickConfirm={dialog.onClickConfirm}
                    setOpen={() => setDialog(null)}
                    open={dialog.open}
                    message={dialog.message}
                />
            )}
            <Loading/>
        </Grid>
    );
};

export default OWAncillaryContent;
